import { z } from 'zod';
import { idSchema } from './common.js';
// -------- Load items (goods, per-stop) --------
const weightKgSchema = z.number().finite().min(0).max(100000);
export const createLoadItemBodySchema = z.object({
    loadStopId: idSchema,
    description: z.string().trim().min(1).max(200),
    quantity: z.number().int().min(1).max(100000).optional(),
    unit: z.string().trim().max(40).nullable().optional(),
    weightKg: weightKgSchema.nullable().optional(),
    reference: z.string().trim().max(80).nullable().optional(),
    notes: z.string().trim().max(4000).nullable().optional(),
});
export const updateLoadItemBodySchema = z
    .object({
    description: z.string().trim().min(1).max(200).optional(),
    quantity: z.number().int().min(1).max(100000).optional(),
    unit: z.string().trim().max(40).nullable().optional(),
    weightKg: weightKgSchema.nullable().optional(),
    reference: z.string().trim().max(80).nullable().optional(),
    notes: z.string().trim().max(4000).nullable().optional(),
})
    .strict();
export const loadItemsParamSchema = z.object({
    fleetId: idSchema,
    loadId: idSchema,
});
export const loadItemIdParamSchema = z.object({
    fleetId: idSchema,
    loadId: idSchema,
    itemId: idSchema,
});
//# sourceMappingURL=load-item.js.map